import LazyImage from "app/components/LazyImage";
import ReactIcon from "app/components/ReactIcon";
import clsx from "clsx";
import React from "react";
import { getInitials } from "utils/helpers";
import { IAvatar } from "../../container/MySetting/types";

export function renderLetter(
  avatar: IAvatar,
  name?: string,
  imageClassName?: string,
  initialClassName?:string
): React.ReactNode {
  const {file,icon}= avatar
  if (file) {
    return (
      <LazyImage
        src={file}
        alt={name}
        className={clsx("size-12 object-cover rounded-md ", imageClassName)}
      />
    );
  }
  if (icon) {
    return <ReactIcon size={16} icon={icon} />;
  }

  return (
    <span className={clsx("text-sm font-medium text-black",initialClassName)}>{getInitials(name)}</span>
  );
}
